import { mount } from 'svelte';
import './styles/tokens.css';
import './styles/layout.css';
import './styles/early-access.css';
import './styles/diff.css';
import './styles/explorer.css';
import './styles/views.css';
import './styles/timeline.css';
import './styles/drafts.css';
import App from './App.svelte';
import { prefs } from './lib/state/prefs.svelte';
import { applyTheme } from './lib/theme';
import { installAppLog } from './lib/feedback/logs';

// Kept in memory only; a feedback report carries it when the reporter ticks App logs.
installAppLog();

applyTheme(prefs.value.theme);

const app = mount(App, { target: document.getElementById('app')! });

export default app;
